import { SvgIcon, SvgIconProps } from '@material-ui/core';

const BackIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M17 1V5H3.83L7.41 1.41L6 0L0 6L6 12L7.41 10.59L3.83 7H19V1H17Z"
        fill="#00558B"
      />
    </SvgIcon>
  );
};

export default BackIcon;
